let cartValidationBlocked = false;


// ======================================================
// FIDELIS - DETECT B2B CUSTOMER
// ======================================================

const isFidelisB2B = () => {

  const drawer =
    document.querySelector(
      ".scd__wrapper"
    );


  const drawerIsB2B =
    drawer &&
    drawer.dataset.fidelisB2b === "true";


  return (
    window.FIDELIS_IS_B2B === true ||
    drawerIsB2B
  );
};


// ======================================================
// VALIDATE CART
// ======================================================

const validateCart = (cart) => {

  console.log(
    "Validating cart:",
    cart
  );


// ======================================================
// B2B
//
// B2C rules must NOT be applied to professional customers.
// Products may define their own B2B minimum quantity through
// the cart property _b2b_minimum_quantity.
// ======================================================

if (isFidelisB2B()) {

  console.log(
    "B2B customer: checking product minimum quantities"
  );


  const messages = [];

  let disableCheckout =
    false;


  if (
    !cart ||
    !Array.isArray(cart.items)
  ) {

    return {
      messages: [],
      disableCheckout: false
    };
  }


  for (const item of cart.items) {

    const minimumQuantity =
      Number(
        item.properties &&
        item.properties._b2b_minimum_quantity
          ? item.properties._b2b_minimum_quantity
          : 0
      );


    const currentQuantity =
      Number(
        item.quantity || 0
      );


    if (
      minimumQuantity > 1 &&
      currentQuantity > 0 &&
      currentQuantity < minimumQuantity
    ) {

      const productTitle =
        item.product_title ||
        item.title ||
        "Este producto";


      messages.push(
        `${productTitle}: el pedido mínimo profesional es de ${minimumQuantity} unidades. Actualmente tienes ${currentQuantity}.`
      );


      disableCheckout =
        true;
    }

  }


  return {
    messages,
    disableCheckout
  };
}

  // ======================================================
  // COUNT PRODUCTS
  // ======================================================

  for (const item of cart.items) {

    const title = `
      ${item.title || ""}
      ${item.product_title || ""}
      ${item.variant_title || ""}
      ${item.handle || ""}
    `.toLowerCase();


    // ------------------------------------------------------
    // Detect jar products
    // ------------------------------------------------------

    const isJarProduct =
      title.includes("tarro") ||
      title.includes("frasco") ||
      title.includes("glass") ||
      title.includes("glas");


    // ------------------------------------------------------
    // Detect frozen products
    // ------------------------------------------------------

    const isFrozenProduct =
      title.includes("congelado") ||
      title.includes("frozen") ||
      title.includes("gefroren");


    // ------------------------------------------------------
    // Count jars
    // ------------------------------------------------------

    if (isJarProduct) {

      const variantTitle =
        (item.variant_title || "")
          .toLowerCase();


      // 800 g jars
      if (
        variantTitle.includes("800")
      ) {

        jarCount800g +=
          Number(item.quantity || 0);

      }

      // 400 g jars
      else if (
        variantTitle.includes("400")
      ) {

        jarCount400g +=
          Number(item.quantity || 0);

      }

      // Products without weight variant
      else {

        jarCount400g +=
          Number(item.quantity || 0);

      }
    }


    // ------------------------------------------------------
    // Count frozen menus
    // ------------------------------------------------------

    if (isFrozenProduct) {

      frozenCount +=
        Number(item.quantity || 0);

    }
  }


  console.log(
    "Jar 400g:",
    jarCount400g
  );

  console.log(
    "Jar 800g:",
    jarCount800g
  );

  console.log(
    "Frozen:",
    frozenCount
  );


  // ======================================================
  // VALIDATION RULES
  // ======================================================

  const messages = [];

  let disableCheckout =
    false;


  // ------------------------------------------------------
  // RULE 1: Glass jars 400 g
  // Must be multiples of 6
  // ------------------------------------------------------

  if (
    jarCount400g > 0 &&
    jarCount400g % 6 !== 0
  ) {

    const nextMultiple400 =
      Math.ceil(
        jarCount400g / 6
      ) * 6;


    const missing400 =
      nextMultiple400 -
      jarCount400g;


    const menuText400 =
      missing400 === 1
        ? "menú"
        : "menús";


    messages.push(
      `Tu caja lleva ${jarCount400g} menús en tarro de 400 g. Añade ${missing400} ${menuText400} más para completar tu caja de ${nextMultiple400}.`
    );


    disableCheckout =
      true;
  }


  // ------------------------------------------------------
  // RULE 2: Glass jars 800 g
  // Must be multiples of 6
  // ------------------------------------------------------

  if (
    jarCount800g > 0 &&
    jarCount800g % 6 !== 0
  ) {

    const nextMultiple800 =
      Math.ceil(
        jarCount800g / 6
      ) * 6;


    const missing800 =
      nextMultiple800 -
      jarCount800g;


    const menuText800 =
      missing800 === 1
        ? "menú"
        : "menús";


    messages.push(
      `Tu caja lleva ${jarCount800g} menús en tarro de 800 g. Añade ${missing800} ${menuText800} más para completar tu caja de ${nextMultiple800}.`
    );


    disableCheckout =
      true;
  }


  // ------------------------------------------------------
  // RULE 3: Frozen menus
  // Must be 12, 24, 36, 48...
  // ------------------------------------------------------

  if (
    frozenCount > 0 &&
    frozenCount % 12 !== 0
  ) {

    const nextFrozenMultiple =
      Math.ceil(
        frozenCount / 12
      ) * 12;


    const frozenMissing =
      nextFrozenMultiple -
      frozenCount;


    const frozenText =
      frozenMissing === 1
        ? "menú"
        : "menús";


    messages.push(
      `Has añadido ${frozenCount} menús congelados. Añade ${frozenMissing} ${frozenText} más para completar tu caja de ${nextFrozenMultiple}.`
    );


    disableCheckout =
      true;
  }


  return {
    messages,
    disableCheckout
  };
};


// ======================================================
// UPDATE UI
// ======================================================

const updateUI = (
  messages,
  disableCheckout
) => {

  cartValidationBlocked =
    disableCheckout;


  const feedbackContainer =
    document.getElementById(
      "cart-feedback"
    );


  // ------------------------------------------------------
  // Display validation messages
  // ------------------------------------------------------

  if (feedbackContainer) {

    feedbackContainer.innerHTML =
      "";


    if (
      messages.length > 0
    ) {

      messages.forEach(
        (message) => {

          const errorDiv =
            document.createElement(
              "div"
            );


          errorDiv.classList.add(
            "alert",
            "alert-danger"
          );


          errorDiv.textContent =
            message;


          feedbackContainer.appendChild(
            errorDiv
          );

        }
      );


      feedbackContainer.classList.remove(
        "hidden"
      );

    } else {

      feedbackContainer.classList.add(
        "hidden"
      );

    }
  }


  // ======================================================
  // FIND ALL CHECKOUT BUTTONS / LINKS
  // ======================================================

  const checkoutSelectors = [
    '[name="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    '.scd__checkout',
    '.cart__checkout',
    '.checkout-button'
  ];


  const checkoutButtons =
    document.querySelectorAll(
      checkoutSelectors.join(",")
    );


  checkoutButtons.forEach(
    (checkoutButton) => {


      // ----------------------------------------------------
      // Standard BUTTON / INPUT
      // ----------------------------------------------------

      if (
        checkoutButton.tagName ===
          "BUTTON" ||
        checkoutButton.tagName ===
          "INPUT"
      ) {

        checkoutButton.disabled =
          disableCheckout;

      }


      // ----------------------------------------------------
      // Visual / accessibility state
      // ----------------------------------------------------

      if (disableCheckout) {

        checkoutButton.setAttribute(
          "aria-disabled",
          "true"
        );


        checkoutButton.classList.add(
          "checkout-disabled"
        );


        checkoutButton.style.opacity =
          "0.5";


        checkoutButton.style.cursor =
          "not-allowed";


        if (
          checkoutButton.tagName ===
          "A"
        ) {

          checkoutButton.style.pointerEvents =
            "none";

        }

      } else {

        checkoutButton.removeAttribute(
          "aria-disabled"
        );


        checkoutButton.classList.remove(
          "checkout-disabled"
        );


        checkoutButton.style.opacity =
          "";


        checkoutButton.style.cursor =
          "";


        checkoutButton.style.pointerEvents =
          "";

      }

    }
  );
};


// ======================================================
// BLOCK CHECKOUT CLICK
// ======================================================

document.addEventListener(
  "click",
  (event) => {

    if (
      !cartValidationBlocked
    ) {
      return;
    }


    const checkoutElement =
      event.target.closest(
        `
        [name="checkout"],
        button[name="checkout"],
        input[name="checkout"],
        a[href*="/checkout"],
        .scd__checkout,
        .cart__checkout,
        .checkout-button
        `
      );


    if (!checkoutElement) {
      return;
    }


    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    console.log(
      "Checkout blocked by cart validation"
    );


    const feedbackContainer =
      document.getElementById(
        "cart-feedback"
      );


    if (feedbackContainer) {

      feedbackContainer.scrollIntoView(
        {
          behavior: "smooth",
          block: "center"
        }
      );

    }


    return false;
  },
  true
);


// ======================================================
// BLOCK CHECKOUT FORM SUBMISSION
// ======================================================

document.addEventListener(
  "submit",
  (event) => {

    if (
      !cartValidationBlocked
    ) {
      return;
    }


    const submitter =
      event.submitter;


    if (
      submitter &&
      (
        submitter.name ===
          "checkout" ||
        submitter.matches(
          ".scd__checkout, .cart__checkout, .checkout-button"
        )
      )
    ) {

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      console.log(
        "Checkout form submission blocked"
      );


      return false;

    }

  },
  true
);


// ======================================================
// FETCH CART AND VALIDATE
// ======================================================

const fetchAndValidateCart =
  async () => {

    try {

      const response =
        await fetch(
          "/cart.js",
          {
            cache: "no-store"
          }
        );


      if (!response.ok) {

        console.error(
          "Failed to fetch cart data:",
          response.statusText
        );


        return;
      }


      const cart =
        await response.json();


      const {
        messages,
        disableCheckout
      } =
        validateCart(cart);


      updateUI(
        messages,
        disableCheckout
      );


    } catch (error) {

      console.error(
        "Error fetching cart data:",
        error
      );

    }

  };


// ======================================================
// MINIMOG CART UPDATE CONNECTION
// ======================================================

const bindFidelisCartEvents =
  () => {

    if (
      window.__fidelisCartEventsBound
    ) {
      return true;
    }


    if (
      typeof MinimogEvents !==
        "undefined" &&
      MinimogEvents &&
      typeof MinimogEvents.subscribe ===
        "function"
    ) {

      MinimogEvents.subscribe(
        "ON_CART_UPDATE",
        async () => {

          console.log(
            "Minimog cart updated"
          );


          // Give Shopify a moment
          // to finish updating the cart
          setTimeout(
            fetchAndValidateCart,
            150
          );

        }
      );


      window.__fidelisCartEventsBound =
        true;


      return true;
    }


    return false;
  };


// ======================================================
// WAIT FOR MINIMOG IF NEEDED
// ======================================================

const waitForFidelisCartEvents =
  () => {

    if (
      bindFidelisCartEvents()
    ) {
      return;
    }


    if (
      window.__fidelisCartEventsRetry
    ) {
      return;
    }


    let attempts =
      0;


    window.__fidelisCartEventsRetry =
      setInterval(
        () => {

          attempts += 1;


          if (
            bindFidelisCartEvents() ||
            attempts >= 40
          ) {

            clearInterval(
              window.__fidelisCartEventsRetry
            );


            window.__fidelisCartEventsRetry =
              null;

          }

        },
        250
      );

  };


// ======================================================
// OBSERVE CART DRAWER
// ======================================================

const initializeDrawerObserver =
  () => {

    const drawerElement =
      document.querySelector(
        ".scd__wrapper"
      );


    if (!drawerElement) {
      return;
    }


    if (
      drawerElement._hasObserver
    ) {
      return;
    }


    drawerElement._hasObserver =
      true;


    const observer =
      new MutationObserver(
        (mutationsList) => {

          mutationsList.forEach(
            (mutation) => {

              if (
                mutation.type ===
                  "attributes" &&
                mutation.attributeName ===
                  "class"
              ) {

                if (
                  !drawerElement.classList.contains(
                    "hidden"
                  )
                ) {

                  console.log(
                    "Drawer opened"
                  );


                  fetchAndValidateCart();

                }

              }

            }
          );

        }
      );


    observer.observe(
      drawerElement,
      {
        attributes: true
      }
    );

  };


// ======================================================
// INITIALIZE SCRIPT
// ======================================================

let cartValidationInitialized =
  false;


function initializeScript() {

  initializeDrawerObserver();

  waitForFidelisCartEvents();


  // Validate immediately
  fetchAndValidateCart();


  if (
    cartValidationInitialized
  ) {
    return;
  }


  cartValidationInitialized =
    true;


  // Retry in case drawer loads later
  setInterval(
    () => {

      const drawerElement =
        document.querySelector(
          ".scd__wrapper"
        );


      if (
        drawerElement &&
        !drawerElement._hasObserver
      ) {

        initializeDrawerObserver();

      }

    },
    1000
  );

}


// ======================================================
// INITIALIZE ON LOAD
// ======================================================

document.addEventListener(
  "DOMContentLoaded",
  initializeScript
);


document.addEventListener(
  "page:load",
  initializeScript
);


document.addEventListener(
  "shopify:section:load",
  initializeScript
);


// ======================================================
// OBSERVE DYNAMICALLY ADDED CART DRAWER
// ======================================================

const dynamicDrawerObserver =
  new MutationObserver(
    () => {

      initializeDrawerObserver();

    }
  );


dynamicDrawerObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);


// ======================================================
// FIDELIS - CROSS SELL CART DRAWER
// B2C ONLY
// ======================================================

document.addEventListener(
  "click",
  async (event) => {

    const button =
      event.target.closest(
        ".fidelis-drawer-cross-sell__add"
      );


    if (!button) {
      return;
    }


    // ------------------------------------------------------
    // Extra safety:
    // B2B must never use B2C cross-sell
    // ------------------------------------------------------

    if (
      isFidelisB2B()
    ) {

      console.log(
        "B2B customer: cross-sell skipped"
      );


      return;
    }


    event.preventDefault();

    event.stopPropagation();


    const variantId =
      Number(
        button.dataset.variantId
      );


    if (
      !variantId ||
      button.dataset.loading ===
        "true"
    ) {
      return;
    }


    const originalText =
      button.textContent;


    button.dataset.loading =
      "true";


    button.disabled =
      true;


    button.textContent =
      "Añadiendo...";


    try {

      // ====================================================
      // ADD PRODUCT TO SHOPIFY CART
      // ====================================================

      const addResponse =
        await fetch(
          "/cart/add.js",
          {
            method: "POST",

            headers: {

              "Content-Type":
                "application/json",

              "Accept":
                "application/json"

            },

            body: JSON.stringify(
              {
                items: [
                  {
                    id: variantId,
                    quantity: 1
                  }
                ],

                sections: [
                  "cart-drawer"
                ],

                sections_url:
                  window.location.pathname
              }
            )
          }
        );


      if (
        !addResponse.ok
      ) {

        throw new Error(
          "Could not add product to cart"
        );

      }


      const addedData =
        await addResponse.json();


      // ====================================================
      // REFRESH CART DRAWER HTML
      // ====================================================

      let drawerUpdated =
        false;


      const sectionHtml =
        addedData.sections &&
        addedData.sections[
          "cart-drawer"
        ];


      if (sectionHtml) {

        const parser =
          new DOMParser();


        const parsedDocument =
          parser.parseFromString(
            sectionHtml,
            "text/html"
          );


        const newDrawer =
          parsedDocument.querySelector(
            ".scd__wrapper"
          );


        const currentDrawer =
          document.querySelector(
            ".scd__wrapper"
          );


        if (
          newDrawer &&
          currentDrawer
        ) {

          const wasOpen =
            !currentDrawer.classList.contains(
              "hidden"
            );


          currentDrawer.replaceWith(
            newDrawer
          );


          if (wasOpen) {

            newDrawer.classList.remove(
              "hidden"
            );


            const newContent =
              newDrawer.querySelector(
                ".scd__content"
              );


            if (newContent) {

              newContent.classList.remove(
                "translate-x-full"
              );


              newContent.classList.add(
                "translate-x-0"
              );

            }

          }


          drawerUpdated =
            true;


          // Reconnect observer to
          // the newly rendered drawer
          initializeDrawerObserver();

        }

      }


      // ====================================================
      // GET UPDATED SHOPIFY CART
      // ====================================================

      const cartResponse =
        await fetch(
          "/cart.js",
          {
            cache: "no-store"
          }
        );


      if (
        !cartResponse.ok
      ) {

        throw new Error(
          "Could not refresh cart"
        );

      }


      const cart =
        await cartResponse.json();


      // ====================================================
      // UPDATE CART COUNTER
      // ====================================================

      const cartCounters =
        document.querySelectorAll(
          "[data-cart-count], .sf-cart-count, .cart-count"
        );


      cartCounters.forEach(
        (counter) => {

          counter.textContent =
            cart.item_count;


          if (
            cart.item_count > 0
          ) {

            counter.classList.remove(
              "hidden"
            );

          }

        }
      );


      // ====================================================
      // RE-RUN FIDELIS VALIDATION
      // ====================================================

      const {
        messages,
        disableCheckout
      } =
        validateCart(cart);


      updateUI(
        messages,
        disableCheckout
      );


      // ====================================================
      // FALLBACK
      // ====================================================

      if (
        !drawerUpdated
      ) {

        console.log(
          "Cart updated. Reloading page as fallback."
        );


        window.location.reload();


        return;

      }


    } catch (error) {

      console.error(
        "Cross-sell add error:",
        error
      );


      button.dataset.loading =
        "false";


      button.disabled =
        false;


      button.textContent =
        originalText;


      alert(
        "No hemos podido añadir el producto al carrito. Inténtalo de nuevo."
      );

    }

  }
);